export default "/_next/static/media/Organic Africa's Veg.177639e36c66b962e5510df6101a8bc7.jpg";